import React from 'react'
import classNames from 'classnames'
import { WithTooltip } from '../generic/WithTooltip'

type Props = {
    comment: string
    className?: string
}

export const EventComment: React.FC<Props> = ({ comment, className }) => {
    return (
        <WithTooltip place="top">
            {ttId => (
                <div
                    className={classNames(
                        className,
                        "font-weight-bold mx-1 user-select-none"
                    )}
                    data-for={ttId}
                    data-tip={comment}
                >
                    {"*"}
                </div>
            )}
        </WithTooltip>
    )
}
